/**
 * Created by liorsion on 7/18/15.
 */
'use strict';

angular.module('bringgApp').config(function ($uibModalProvider) {
	$uibModalProvider.options.animation = false;
});
